import React from "react";
import { describeArc } from "../../utils/svgUtils";
import { nakshatraLords, getNakshatraColor, getRashiForPada } from "../../utils/astroUtils";

const ClockFace = ({ size, center, radius }) => {
  const outerFrameRadius = radius + 40;
  const labelRadius = radius - 20;
  const totalPadas = 27 * 4;
  const anglePerPada = 360 / totalPadas;
  const nakshatraNames = Object.keys(nakshatraLords);

  return (
    <g>
      <defs>
        <clipPath id="galaxy-clip">
          <circle cx={center} cy={center} r={outerFrameRadius} />
        </clipPath>
      </defs>

      {/* Galaxy Background */}
      <image
        href="/assets/galaxy_bg.webp"
        x={center - outerFrameRadius}
        y={center - outerFrameRadius}
        width={outerFrameRadius * 2}
        height={outerFrameRadius * 2}
        clipPath="url(#galaxy-clip)"
        preserveAspectRatio="xMidYMid slice"
        style={{ filter: "brightness(0.55)" }}
      />

      {/* Outer Frame */}
      <circle
        cx={center}
        cy={center}
        r={outerFrameRadius}
        fill="none"
        stroke="var(--accent-gold)"
        strokeWidth="3"
        style={{ filter: "drop-shadow(0 0 6px rgba(229,188,34,0.3))" }}
      />

      {/* Main Circle */}
      <circle
        cx={center}
        cy={center}
        r={radius}
        fill="rgba(255,255,255,0.03)"
        stroke="rgba(255,255,255,0.1)"
        strokeWidth="2"
        filter="url(#glass-light)"
      />

      {Array.from({ length: totalPadas }).map((_, i) => {
        const startAngle = i * anglePerPada;
        const endAngle = startAngle + anglePerPada;
        const midAngle = (startAngle + endAngle) / 2;
        const nakshatraIndex = Math.floor(i / 4);
        const padaIndex = i % 4;
        const nakshatraName = nakshatraNames[nakshatraIndex];
        const baseColor = getNakshatraColor(nakshatraName);

        const shade = 1 - padaIndex * 0.15;
        const r = Math.floor(parseInt(baseColor.slice(1, 3), 16) * shade);
        const g = Math.floor(parseInt(baseColor.slice(3, 5), 16) * shade);
        const b = Math.floor(parseInt(baseColor.slice(5, 7), 16) * shade);
        const strokeColor = `rgba(${r}, ${g}, ${b}, 0.25)`; // Faded

        const pathData = describeArc(center, center, radius, startAngle, endAngle);
        const radians = (midAngle - 90) * (Math.PI / 180);
        const textX = center + labelRadius * Math.cos(radians);
        const textY = center + labelRadius * Math.sin(radians);

        return (
          <g key={`pada-${i}`}>
            <path d={pathData} fill="none" stroke={strokeColor} strokeWidth="1.2" />
            <text
              x={textX}
              y={textY}
              fontSize="9"
              fill="white"
              fontWeight="bold"
              textAnchor="middle"
              dominantBaseline="middle"
              transform={`rotate(${midAngle}, ${textX}, ${textY})`}
              style={{ textShadow: "0 0 3px black", pointerEvents: "none" }}
            >
              <tspan x={textX} dy="-0.5em">{padaIndex + 1}</tspan>
              <tspan x={textX} dy="1.8em" fontSize="10">{getRashiForPada(i)}</tspan>
            </text>
          </g>
        );
      })}
    </g>
  );
};


export default ClockFace;
